import React from 'react';
import moment from 'moment-timezone';

// redux
/*
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { addCurrentUserAction } from '../../actions/current_user'
*/

// my components
import Tweets from '../../components/tweets/tweets';

// my helpers
import { pageRootUpdate, externalNewsUrl } from '../../helpers/api_routes';
import { t } from '../../locales/translations';

// for fetching data from server
import axios from 'axios';
import { useState } from 'react';
import { useEffect } from 'react';
import LazyLoad from 'react-lazyload';
import Seo from '../../components/seo/seo';
import spinner from '../../images/spinner.svg';

const maxNewsItems = 10;

const latestNewsItems = items => {
	return [ ...items ]
		.sort((a, b) => {
			const bDate = b.publish_at ? moment(b.publish_at).valueOf() : 0;
			const aDate = a.publish_at ? moment(a.publish_at).valueOf() : 0;
			return bDate - aDate;
		})
		.slice(0, maxNewsItems);
};

const newsLoader = () => (
	<div className="center">
		<img src={spinner} alt="Loading news" />
	</div>
);

const NewsExternalIndex = (props) => {
	const [ newsItems, setNewsItems ] = useState([]);
	const [ errors, setErrors ] = useState(null);
	const [ isLoading, setIsLoading ] = useState(true);

	useEffect(() => {
		axios
			.get(externalNewsUrl.index)
			.then(function(response) {
				// backend should take care off pagination
				setNewsItems(response.data.external_news_items.items);
				setIsLoading(false);
			})
			.catch(function(error) {
				setErrors(t('sorry_error'));
				setIsLoading(false);
			});
	}, []);

	function makeNewsItems(items) {
		if (isLoading) {
			return newsLoader();
		}

		let list =
			items.length > 0 && items.filter((obj) => obj.name !== "churchofengland").map((obj) => obj.news_items);
		list = list.length > 0 && [].concat(...list);

		if (list && list.length > 0) {

			return latestNewsItems(list).map((item, index) => (
				<div key={item.id} className='card card--horizontal card--news' data-aos="fade-up">
					<div className='card__img'>
						<LazyLoad>
						{item.image ? <img src={`${pageRootUpdate}${item.image}`} alt='news' /> : <div className="empty-image"></div>}
						</LazyLoad>
					</div>
					<div className='card__body black'>
						<p className='color-primary'>
							{item.publish_at && <span>{moment(item.publish_at, 'YYYY-MM-DD').format('DD.MM.YYYY')}</span>}
						</p>
						<div className='text--xlarge card__title'>{item.title}</div>
						<p className='card__copy black'>{item.description}</p>
					</div>
					<div className='card__btn'>
						<a href={item.url} target='_blank' className='overlay-link' rel='noopener noreferrer'>
							Read more
						</a>
					</div>
				</div>
			));
		} else {
			return <div><h2 className="white">No News Found</h2></div>;
		}
	}

	return (
		<div className='view--news'>
			<Seo
				pageSeo={{
					seo_title: `News from the Diocese | ${props.churchName}`,
					seo_description: 'Checkout the latest news from the Diocese'
				}}
			/>
			<div className='layout--main'>
				{/*NewsItems*/}
				<div className='grid'>
					<div className='cell cell--12--large cell--12--small'>
						<section className='section--offset section--primary section--padded--tb'>
							<div className='list'>{makeNewsItems(newsItems)}</div>
							<p>{errors}</p>
						</section>
					</div>
				</div>

				<section className='tweets-section'>
					<Tweets handles={['chelmsdio']} />
				</section>
			</div>
		</div>
	);
};

export default NewsExternalIndex;
